exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dialog_slider_cv{\n  width: 950px;\n  height: 85vh;\n  margin: -12px;\n  padding: 0px;\n}\n\n.arrow_slider .fa{\n  cursor: pointer;\n}\n\n.arrow_slider{\n  position: absolute;\n  z-index: 2;\n  margin-top: 30vh;\n  font-size: 50px;\n  color: #FFF;\n}\n\n.arrow_left{\n  left: calc(50% - 450px - 60px);\n}\n\n.arrow_right{\n  right: calc(50% - 450px - 60px);\n}\n\n.btn_close{\n  width: auto;\n  float: right;\n  margin-top: 20px;\n  margin-bottom: -41px;\n  z-index: 2;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/slider-cv/slider-cv.component.css
// module id = ../../../../../src/app/pages/slider-cv/slider-cv.component.css
// module chunks = main